"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const OrderInfoView_1 = require("./OrderInfoView");
const OrderProductsInfo_1 = require("./OrderProductsInfo");
const Layout_1 = require("../../Layout");
function OrderView({ authenticated, data, loading, logo, mail, id, }) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(Layout_1.Layout, { logo: logo, left: (0, jsx_runtime_1.jsx)(OrderInfoView_1.OrderInfoView, { data: data, authenticated: authenticated, loading: loading, id: id, mail: mail }), right: (0, jsx_runtime_1.jsx)(OrderProductsInfo_1.OrderProductsInfo, { order: data, tracking: true, loading: loading, authenticated: authenticated, shipping: (_a = data === null || data === void 0 ? void 0 : data.shipping) === null || _a === void 0 ? void 0 : _a.price.amount }) }));
}
exports.OrderView = OrderView;
